import React from 'react';
import styled from 'styled-components';

const CheckBoxContainer = styled.div<{ $hasLabel?: boolean }>`
  display: flex;
  align-items: center;
  gap: 4px;

  min-width: ${({ $hasLabel }) => ($hasLabel ? '55px' : 'auto')};
  margin-left: auto;

  cursor: pointer;

  > p {
    margin: 0;

    color: #989ba2;
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
  }
`;

const Container = styled.input`
  width: 24px;
  height: 24px;
  -webkit-appearance: none; /* 기본 스타일 제거 */
  -moz-appearance: none;
  appearance: none;
  background-color: #fff; /* 기본 배경색 */
  border: 1px solid; /* 테두리 */
  border-color: #ddd;
  cursor: pointer;
  display: inline-block;
  position: relative;
  border-radius: 5px;
  z-index: 1;

  &:checked {
    background-color: #414b56;
    border-color: #414b56 !important;
  }

  &:checked::before {
    content: '✓';
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    color: white;
  }
`;

interface CheckBoxIProps {
  isChecked: boolean;
  style?: React.CSSProperties;
  onChange: () => void;
  label?: string;
  labelStyle?: React.CSSProperties;
}

const CheckBox: React.FC<CheckBoxIProps> = props => {
  const { isChecked, style, onChange, label, labelStyle } = props;

  return (
    <CheckBoxContainer
      $hasLabel={!!label}
      onClick={e => {
        e.stopPropagation();

        onChange();
      }}
    >
      <Container type="checkbox" checked={!!isChecked} style={{ ...style }} />

      {label && <p style={{ ...labelStyle }}>{label}</p>}
    </CheckBoxContainer>
  );
};

export default CheckBox;
